import {CaseStatus} from 'app/shared/model/enumerations/case-status.model';
import {CaseType} from 'app/shared/model/enumerations/case-type.model';
import {ContactRelation} from 'app/shared/model/enumerations/contact-relation.model';
import {FollowUpResult} from 'app/shared/model/enumerations/follow-up-result.model';
import {ReasonForTransfer} from 'app/shared/model/enumerations/reason-for-transfer.model';
import {IJourney} from 'app/shared/model/journey.model';
import {IPatient} from 'app/shared/model/patient.model';
import {ISymptom} from 'app/shared/model/symptom.model';
import {EmergencyType} from "app/shared/model/enumerations/emergency-type.model";

export interface IPatientCase {
  emergency?: boolean;
  bypass?: boolean;
  patientFeedbackId?: string;
  emergencyType?: EmergencyType;
  activated?: any;
  id?: string;
  type?: CaseType;
  caseStatus?: CaseStatus;
  primaryContactType?: ContactRelation;
  primaryContactName?: string;
  primaryContactNumber?: string;
  secondaryContactNumber?: string;
  reasonForTransferType?: ReasonForTransfer;
  reasonForTransferId?: string;
  reasonForTransferDescription?: string;
  followUpResult?: FollowUpResult;
  followUpMessage?: string;
  createdAt?: Date;
  motherSymptom?: string;
  babySymptom?: string;
  motherSymptoms?: ISymptom[];
  babySymptoms?: ISymptom[];
  motherFollowupId?: any;
  motherConditionId?: any;
  journeys?: IJourney[];
  patient?: IPatient;
  isDelivered?: boolean;
}

export const defaultValue: Readonly<IPatientCase> = {};
